import service from "./service"

const updateIcoverCredentials = async (payload) => {
    return service(payload)
}
export default updateIcoverCredentials
